/* cc-faqs — accordion behavior for the "Quick answers" card.
   1:1 behavior port of Empire's inline script (2026-07-09): one item
   open at a time, height animated via inline transition (0.2s ease =
   the system's --cc-duration/--cc-ease), collapse-others on open.
   Custom element so re-rendered markup re-inits; no observers. */
(() => {
  if (customElements.get('cc-faqs')) return;

  const DURATION_MS = 200; // keep in sync with the inline transitions below

  class CCFaqs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ccInit) return;
      this.dataset.ccInit = '1';

      const items = Array.from(this.querySelectorAll('details.cc-faq-item'));

      // Belt: CSS already sets .cc-faq-a to height 0.
      items.forEach((d) => {
        const c = d.querySelector('.cc-faq-a');
        if (c && !d.open) c.style.height = '0px';
      });

      const openAnim = (d) => {
        const c = d.querySelector('.cc-faq-a');
        const inner = d.querySelector('.cc-faq-a-inner');
        if (!c || !inner) return;
        c.style.transition = 'height 0.2s ease';
        c.style.height = '0px';
        requestAnimationFrame(() => {
          c.style.height = inner.scrollHeight + 'px';
        });
        setTimeout(() => {
          c.style.transition = '';
          c.style.height = 'auto';
        }, DURATION_MS + 40);
      };

      const closeAnim = (d) => {
        const c = d.querySelector('.cc-faq-a');
        const inner = d.querySelector('.cc-faq-a-inner');
        if (!c || !inner) return;
        c.style.transition = 'height 0.2s ease';
        c.style.height = inner.scrollHeight + 'px';
        requestAnimationFrame(() => {
          c.style.height = '0px';
        });
      };

      items.forEach((d) => {
        d.addEventListener('toggle', () => {
          if (d.open) {
            items.forEach((other) => {
              if (other !== d && other.open) {
                other.open = false;
                closeAnim(other);
              }
            });
            openAnim(d);
          } else {
            closeAnim(d);
          }
        });
      });
    }
  }

  customElements.define('cc-faqs', CCFaqs);
})();
